/**
 * @generated SignedSource<<ff4de502429ab7cff7d21ab7cf85dbbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountTab_QueryFragment$data = {
  readonly AccountBaseData: {
    readonly AccountBaseData: {
      readonly __typename: string;
      readonly " $fragmentSpreads": FragmentRefs<"businessAccountForm_BaseDataFragment" | "privateAccountForm_BaseDataFragment">;
    };
  };
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly accounts: ReadonlyArray<{
          readonly groupAssociations: ReadonlyArray<{
            readonly group: {
              readonly name: string;
            } | null;
          }>;
          readonly id: string;
          readonly name: string;
        }>;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"accountContextMenu_AuthViewerSchemaFragment">;
    };
  };
  readonly " $fragmentType": "accountTab_QueryFragment";
};
export type accountTab_QueryFragment$key = {
  readonly " $data"?: accountTab_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"accountTab_QueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./accountTabRefetchQuery.graphql')
    }
  },
  "name": "accountTab_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountBaseDataQueries",
      "kind": "LinkedField",
      "name": "AccountBaseData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "AccountBaseData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "businessAccountForm_BaseDataFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "privateAccountForm_BaseDataFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ViewerQueryType",
      "kind": "LinkedField",
      "name": "Viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AuthViewerSchema",
          "kind": "LinkedField",
          "name": "Auth",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "accountContextMenu_AuthViewerSchemaFragment"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CurrentUser",
              "kind": "LinkedField",
              "name": "currentUser",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Account",
                  "kind": "LinkedField",
                  "name": "accounts",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AccountGroupAssociation",
                      "kind": "LinkedField",
                      "name": "groupAssociations",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "AccountGroup",
                          "kind": "LinkedField",
                          "name": "group",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "ad9a76848134465e051277a8def6b259";

export default node;
